import React from 'react'
import Header from '../components/Layouts/Header'
import Footer from '../components/Layouts/Footer'
import CourseViewLesson from '../components/CourseViewLesson/CourseViewLesson'

const CourseLesson = () => {
  return (
    <>
        <Header />
        <CourseViewLesson />
        <Footer />
    </>
  )
}

export default CourseLesson;